import React from 'react';
import { connect } from 'react-redux';
import StatisticsByCreativeMetrics from './StatisticsByCreativeMetrics.js';
import actions from './StatisticsByCreativeMetrics.actions';
import {
    mainSelector,
    getMetrics
} from './StatisticsByCreativeMetrics.selectors';
import ReportByCreativeComponent from '../../../../utils/ReportByCreativeComponent/ReportByCreativeComponent';

const reportUtils = ReportByCreativeComponent.utils;

const StatisticsByCreativeMetricsComponent = connect(
    function mapStateToProps(state, ownProps) {
        const data = mainSelector(state);
        const fallbackMetrics = getMetrics(state);
        const metrics = typeof ownProps.metrics === 'string' && ownProps.metrics.length
            ? ownProps.metrics
            : fallbackMetrics;
        const checkedKeys = reportUtils.getKeysMetric(metrics || reportUtils.getDefStrMetric());

        return {
            data,
            metrics,
            checkedKeys,
            location: state.routing.locationBeforeTransitions
        };
    },
    function mapDispatchToProps(dispatch) {
        return {
            saveServerStorage: actions.saveServerStorage
        };
    }
)(StatisticsByCreativeMetrics);

export default StatisticsByCreativeMetricsComponent;
